/**
 * AnnouncementType model translations
 *
 * Drives the user-managed Type de mémo taxonomy (Avis important, Bienvenue, …).
 */
export default {
  en: {
    singular: "Memo Type",
    plural: "Memo Types",

    fields: {
      name: "Name",
      color: "Color",
      is_default: "Default",
      sort_order: "Sort order",
    },

    badges: {
      true: "Default",
      false: "—",
    },

    tabs: {
      main: "Details",
    },
  },

  fr: {
    singular: "Type de mémo",
    plural: "Types de mémo",

    fields: {
      name: "Nom",
      color: "Couleur",
      is_default: "Par défaut",
      sort_order: "Ordre",
    },

    badges: {
      true: "Par défaut",
      false: "—",
    },

    tabs: {
      main: "Détails",
    },
  },
};
